import DockingViewState from '../../../store/schema/DockingViewState';
import { action } from 'satcheljs/lib/legacy';

const updateDocking = action('updateDocking')(function updateDocking(
    dockingViewState: DockingViewState,
    isTopDocking: boolean,
    isBottomDocking: boolean,
    scrollLeft: number,
    scrollBarHeight: number,
    dockingWidth: number,
    bottomDockingBottom: number
) {
    dockingViewState.isTopDocking = isTopDocking;
    dockingViewState.isBottomDocking = isBottomDocking;
    dockingViewState.dockingWidth = dockingWidth;
    dockingViewState.scrollLeft = scrollLeft;
    dockingViewState.scrollBarHeight = scrollBarHeight;
    dockingViewState.bottomDockingBottom = bottomDockingBottom;
});

export const updateStickyDocking = action('updateStickyDocking')(function updateStickyDocking(
    dockingViewState: DockingViewState,
    isBottomDocking: boolean
) {
    dockingViewState.isBottomDocking = isBottomDocking;
});

export { updateDocking };

export default function calculateDocking(
    dockingViewState: DockingViewState,
    scrollContainerScrollTop: number,
    scrollContainerScrollLeft: number,
    scrollContainerClientHeight: number,
    scrollContainerOffsetHeight: number,
    scrollBodyOffsetTop: number,
    scrollBodyOffsetHeight: number,
    composeBodyWidth: number
) {
    const isTopDocking =
        scrollBodyOffsetTop <= scrollContainerScrollTop + dockingViewState.topDockingHeight &&
        scrollBodyOffsetTop +
            scrollBodyOffsetHeight -
            scrollContainerScrollTop -
            dockingViewState.topDockingHeight >
            dockingViewState.minBodyHeight;
    const isBottomDocking =
        scrollBodyOffsetTop + scrollBodyOffsetHeight >=
        scrollContainerScrollTop +
            scrollContainerClientHeight -
            dockingViewState.bottomDockingHeight;

    const bottomDockingBottom = Math.min(
        scrollContainerScrollTop +
            scrollContainerClientHeight -
            scrollBodyOffsetTop -
            dockingViewState.bottomDockingHeight -
            dockingViewState.minBodyHeight,
        0
    );
    const scrollBarHeight = scrollContainerOffsetHeight - scrollContainerClientHeight;

    if (
        isTopDocking != dockingViewState.isTopDocking ||
        isBottomDocking != dockingViewState.isBottomDocking ||
        composeBodyWidth != dockingViewState.dockingWidth ||
        scrollContainerScrollLeft != dockingViewState.scrollLeft ||
        scrollBarHeight != dockingViewState.scrollBarHeight ||
        bottomDockingBottom != dockingViewState.bottomDockingBottom
    ) {
        updateDocking(
            dockingViewState,
            isTopDocking,
            isBottomDocking,
            scrollContainerScrollLeft,
            scrollBarHeight,
            composeBodyWidth,
            bottomDockingBottom
        );
    }
}
